const DeviceCard = ({
    header,
    subHeader,
    meta = [],
    rightContent,
    footer,
    onClick
  }) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
          borderRadius: "12px",
          maxWidth:"400px",
          boxShadow: "0 0 4px rgba(0,0,0,0.15)",
          padding: "20px",
          gap: "8px",
          cursor: onClick ? "pointer" : "default"
        }}
        onClick={onClick}
      >
        {/* Main row */}
        <div style={{ display: "flex", justifyContent: "space-between", gap:"8px" }}>
          {/* LEFT */}
          <div style={{ minWidth: 0, overflow:"hidden", textOverflow:"ellipsis", gap:"8px", maxWidth:"80%" }}>
            <h3 style={{color:"#585966", fontSize:500, fontSize:"17px", marginBottom:"5px"}}>{header}</h3>
            {subHeader && <h4 style={{ margin: 0, color:"#585966", marginBottom:"5px", fontSize:"13px", fontWeight:500 }}>{subHeader}</h4>}
  
            {meta.map((line, i) => (
              <p key={i} 
                style={{ 
                    color:"#969696", 
                    fontWeight: 450, 
                    fontSize: "14px", 
                    margin: 0,  
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical" 
                }}>
                {line}
              </p>
            ))}
          </div>
  
          {/* RIGHT */}
          <div style={{ minWidth:0, display: "flex", overflow:"hidden", textOverflow:"ellipsis", flexDirection:"column", alignItems:"flex-end", marginRight:"4px", fontSize:"12px", gap:"5px"}}>
            {rightContent}
          </div>
        </div>
  
        {/* FOOTER */}
        {footer && (
          <div style={{ fontSize: "10px", opacity: 0.8 }}>
            {footer}
          </div>
        )}
      </div>
    );
  };

  export default DeviceCard;
   